import React from 'react'
import styled from 'styled-components'
import { Alert } from 'antd'
import { useSelector } from 'react-redux'
import { selectCountry } from 'containers/Base/selectors'
import { COUNTRIES } from '@nv/react-commons/src/Constants'
import { intl } from 'containers/IntlGlobalProvider'

const StyledBanner = styled(Alert)`
  && {
    background-color: #dc3545;
    border: 1px solid #dc3545;
    color: white;
    border-radius: 0;
    margin: 0;
    padding: 16px 24px;
    width: 100%;
    min-height: auto;
    
    .ant-alert-message {
      color: white;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      margin-right: 24px;
    }
    
    .ant-alert-close-icon {
      color: white;
      font-size: 16px;
      
      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
    
    .anticon {
      display: none; // Hide the default icon
    }
  }
`


export const NotificationBanner = () => {
  const country = useSelector(selectCountry())

  // Only show banner for VN country
  if (country?.toLowerCase() !== COUNTRIES.VN) {
    return null
  }

  return (
    <StyledBanner
      message={intl.formatMessage({ id: 'notification_banner_message' })}
      type="error"
      closable={false}
      banner
    />
  )
}
